import type { Resource } from '../../';
export const general_errors_renderAlerts_title_inRenderDev: Resource = {"default":"Component \"{componentName}\" failed to render."};
